module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBRAPCi4ixGq+AAAAaUlEQVQ4y7WUuxGAQAgF94ytylLswTZM/VdztVgHBpcZODxGiHcZGD7wHYWZmwFnFC4MY/LiJ4ZR6X34kYrvqfim4Wsqvig4jB688+X6qSS56bAiDa4p0mqEFWm9w4p0ok2RnkBTXm/mAfAVSgjUEsBbAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA1LTE2VDE1OjEwOjQ2KzAyOjAwJbooPAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0wNS0xNlQxNToxMDo0NiswMjowMFTnkIAAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./scripts/src/assets/icons/black/back1.png
// module id = 294
// module chunks = 0